import { useTranslation } from 'react-i18next';

import { PlusIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { AddSubtenantModal } from './modals/add-subtenant-modal';
import { useModal } from '@/components/modals/new/use-modal';

export const AddSubTenantButton = ({ tenantId }: { tenantId: string }) => {
  const { t } = useTranslation();
  const modal = useModal();

  return (
    <>
      <Button variant="outline" onClick={modal.open}>
        <PlusIcon />
        <span className="sr-only md:not-sr-only">{t('add-subtenant')}</span>
      </Button>
      <AddSubtenantModal tenantId={tenantId} modal={modal} />
    </>
  );
};
